import { useQuery } from '@tanstack/react-query';

import { AxiosRequestConfig } from 'axios';

import { getMyEntitlementGroups } from 'api/usersService';

/**
 * A custom hook for all tiles related things from the UsersService.
 *
 * @returns DefinedUseQueryResult<Tile[], Error>
 */
export const useSelfEntitlementGroupsQuery = (config?: AxiosRequestConfig) => {
  const query = useQuery({
    queryKey: ['myEntitlementGroups'],
    queryFn: () => {
      const entitlementGroups = getMyEntitlementGroups(config);
      return entitlementGroups;
    },
    initialData: []
  });

  return query;
};
